import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { formatBytes } from "../../../../helper/converters";
import { IFiles, IItemFile } from "../../../../config/interfaces";
import './index.scss'

const CreativeFile = (props: IItemFile) => {
  const { file, styles } = props;

  const openFile = (doc: IFiles) => {
    window.open(doc.file
      ? doc.file
      : doc.link_url?.match(/^https?:/)
        ? doc.link_url
        : `//${doc.link_url}`);
  }

  return (
    <div
      style={{
        cursor: 'pointer'
      }}
      onClick={() => openFile(file)}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          borderStyle: "solid",
          borderColor: "#E5E5E5",
          borderRadius: "9px",
          opacity: 1,
          padding: "1em",
          margin: "0.7em 0",
          backgroundColor: styles?.backgroundColor
            ? styles.backgroundColor
            : "transparent",
          borderWidth: 1,
        }}
        aria-haspopup="true"
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: '100%'
          }}
        >
          <img src="https://cinemahive.s3.amazonaws.com/images/locations/Group+71518.svg" />
          <Box
            sx={{
              overflow: 'hidden',
            }}
          >
            <Typography
              component="p"
              variant="h5"
            >
              {file.name ? file.name : file.file_name}
            </Typography>
            <Typography
              component="p"
              variant="body2"
              className="multiline"
            >
              {file.size ? formatBytes(file.size) : file.link_url || ""}
            </Typography>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default CreativeFile;
